import { IConfigStateGroups, ITag, Results, Subtask, Task } from 'constants/interfaces'
import { extractSubstringAfterDelimiter } from 'utils'
import { appendIdentityParams, isExternalFormLink } from 'utils/jotformLink'
import { findScopedResult } from './results'

export const isServiceManagedLink = (subtask: Pick<Subtask, 'external_link' | 'is_external_status_update'>) =>
  !!subtask.external_link && isExternalFormLink(subtask.external_link) && !subtask.is_external_status_update

type getFormattedLinkProps = {
  link: string
  tasks: Task[]
  task?: Task
  tid: string
  st_id: string
  contextId: string
  uid: string
  userResults: Results
  rid: string
  tags: ITag[]
  first_name: string
  last_name: string
  default_group: string | null
  groups: IConfigStateGroups
  activeGroupID: string
  isFirstResult?: boolean
}
export const getFormattedLink = ({
  link,
  tasks,
  task: selectedTask,
  tid,
  st_id,
  contextId,
  uid,
  userResults,
  rid,
  first_name,
  last_name,
  default_group,
  groups,
  isFirstResult: firstResultOverride,
}: getFormattedLinkProps) => {
  if (!isExternalFormLink(link)) {
    return link
  }
  const task = selectedTask?.tid === tid ? selectedTask : tasks.find((task) => task.tid === tid)
  if (!task) {
    throw new Error('Task not found')
  }
  const version = 2
  const utc_offset = 3
  const { recipient_type, recurrence_start_time, is_individual_results, recurrence_ts } = task
  // The modal owns result context and occurrence; cached task rows may represent another recurrence.
  const userResultOfCurrentSubtask = findScopedResult(userResults?.[tid], st_id, contextId, recurrence_ts)
  const task_context_id = extractSubstringAfterDelimiter(task.retail_id_context_id, rid)

  const isFirstResult = firstResultOverride ?? !userResultOfCurrentSubtask

  return appendIdentityParams(
    link,
    { first_name, last_name, default_group, groups, user_id: uid },
    {
      task_id: tid,
      subtask_id: st_id,
      version,
      is_individual_results,
      context_id: contextId,
      is_first_result: isFirstResult,
      recurrence_ts,
      recurrence_start_time,
      utc_offset,
      recipient_type,
      task_context_id,
    }
  )
}
